import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();
import Cookies from 'js-cookie';

function redirectTopis(){
    Cookies.set("showDueDatemsg", "true");
    window.location.href = "/tools/pregnancy-checkup-schedule/";
}

export default function PISsection ({pisData, eleRef}){
console.log("PIS -- ", global.userAry['IsExpected']);
    return(
        <section className="pis-section">
            <div className="section-title">PREGNANCY INSPECTION SCHEDULE</div>
            {global.ftk && global.userAry['IsExpected'] ?
            <div>
            {pisData.data && pisData.data.map((pis, id) => 
            <div key={id} className="vacc-block">
                <div className="vacc-details">
                    <div className="vacc-img-det left">
                        <a href={`/tools/pregnancy-checkup-schedule/manageReports/${pis.title}/${pis.id}`}>
                            <div className={`vacc-img vacc-${pis.status}`}>
                                <span data-icon-font="S"></span>
                            </div>
                            <div className="M14_42 vaccine-name">
                                {pis.title}
                            </div>
                        </a>
                    </div>
                    <div className="vacc-info left">
                        <div className="due-on-reminder">
                            <div className="M12_42">Due on</div>
                            <div className="M12_42">Reminder set for</div>
                        </div>
                        <div className="dates">
                            <div className="vacc_dt">
                                {pis.dueOn}
                            </div>
                            <div className="vacc_dt">
                            <a className="vacc_dt dev_vac_dt" href={`/tools/pregnancy-checkup-schedule/manageReminder/${pis.id}/${pis.title}`}>{pis.reminderDate}<span className="" data-icon-font="w"></span></a>
                            </div>
                        </div>
                        <div className="vacc-descp line-clamp R14_75">
                            {pis.desc}
                        </div>
                        <div className="vacc-readmore R13_link"><a href={pis.url} className="R13_link dev_vac_dtl">Read More</a></div>
                    </div>
                </div>
            </div>
            )}
            {pisData.search_cnt > pisData.data.length &&
            <div className="moreResults dev_v_all" title="PREGNANCY INSPECTION SCHEDULE" onClick={()=>eleRef.getMoreSearchData(pisData.type)}>SEE MORE RESULTS</div>
            }
            </div>
            : 
            <div className="non_loggedin" id="non_loggedin">
                {pisData.data && pisData.data.map((pis, id) => 
                <div key={id} className="vacc-block">
                    <div className="vacc-details">
                        <div className="vacc-img-det left">
                        {!global.ftk ?
                        <div className={pis.status ? `vacc-img vacc-${pis.status}` : 'vacc-img vacc-upcoming'} onClick={() => actions.nonLoggedin()}>
                            <span data-icon-font="S"></span>
                        </div>
                            :
                        <div className={pis.status ? `vacc-img vacc-${pis.status}` : 'vacc-img vacc-upcoming'} onClick={() => redirectTopis()}>
                            <span data-icon-font="S" id="dev_art_dtl"></span>
                        </div>
                        }
                        </div>
                        <div className="vacc-info left">
                        {!global.ftk ?
                            <div className="M14_42 vacc-name" onClick={() => actions.nonLoggedin()}>{pis.title}</div>
                            :
                            <div className="M14_42" id="dev_pis_title" onClick={() => redirectTopis()}>{pis.title}</div>
                        }
                            <div className="vacc-descp line-clamp R14_75" id="dev_pis_dtl">{pis.desc}</div>
                            <div className="vacc-readmore R13_link"><a href={pis.url} className="R13_link dev_art_dtl">Read More</a></div>
                        </div>
                    </div>
                </div>
                )}
                {!global.ftk ?
                <div className="moreResults dev_v_all" title="PREGNANCY INSPECTION SCHEDULE" onClick={()=>actions.nonLoggedin()}>SEE MORE RESULTS</div> 
                :
                pisData.search_cnt > pisData.data.length &&
                <div className="moreResults dev_v_all" title="PREGNANCY INSPECTION SCHEDULE" onClick={()=>eleRef.getMoreSearchData(pisData.type)}>SEE MORE RESULTS</div>
                }
            </div>
            }
            
        </section>
    );
}
